import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Typography from '../Typography';
import { default as withStyles } from '../styles';
import { spacing30, spacing40, spacing60, sizingXxSmall, sizingXxLarge, borderRadiusLarge } from '../styles/tokens';
export var styles = function styles(theme) {
  return {
    paper: {
      padding: 0,
      backgroundColor: 'transparent',
      border: 'none',
      boxShadow: 'none'
    },
    drawer: {
      borderTopLeftRadius: borderRadiusLarge,
      borderTopRightRadius: borderRadiusLarge,
      backgroundColor: theme.palette.grey[100],
      paddingTop: spacing40,
      paddingBottom: spacing60
    },
    title: {
      paddingLeft: spacing40,
      paddingRight: spacing40
    },
    knob: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      padding: spacing30,
      '& > div': {
        width: sizingXxLarge,
        height: sizingXxSmall,
        backgroundColor: theme.palette.grey[100],
        borderRadius: borderRadiusLarge
      }
    }
  };
};
/**
 * DrawerWrapper
 */

var DrawerWrapper = function DrawerWrapper(props) {
  var classes = props.classes,
      open = props.open,
      handleClose = props.handleClose,
      children = props.children,
      title = props.title,
      DrawerProps = props.DrawerProps,
      TitleTypographyProps = props.TitleTypographyProps,
      id = props.id;
  return /*#__PURE__*/React.createElement(SwipeableDrawer, _extends({
    anchor: "bottom",
    open: open,
    onOpen: function onOpen() {} // This is required API, but action menu button is toggling it.
    ,
    onClose: handleClose,
    "data-testid": "eds-mobile-drawer",
    className: "eds-mobile-drawer",
    classes: {
      paper: classes.paper
    }
  }, DrawerProps), /*#__PURE__*/React.createElement("div", {
    className: classes.knob,
    onClick: handleClose
  }, /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement("div", {
    id: id,
    className: classes.drawer
  }, title && /*#__PURE__*/React.createElement(Typography, _extends({
    variant: "h3",
    className: classes.title
  }, TitleTypographyProps), title), children));
};

DrawerWrapper.propTypes = {
  handleClose: PropTypes.func,
  children: PropTypes.node.isRequired,
  open: PropTypes.bool,
  classes: PropTypes.object,
  className: PropTypes.string,
  PaperProps: PropTypes.object,
  TitleTypographyProps: PropTypes.object,
  TextTypographyProps: PropTypes.object,
  title: PropTypes.string,
  id: PropTypes.string,
  DrawerProps: PropTypes.object
};
export default withStyles(styles)(DrawerWrapper);